var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from "react";
import classNames from "classnames";
import { QuiIcon } from "../_primitives/QuiIcon/QuiIcon.js";
const QUI_BADGE_ICON_SIZE = {
    xs: "xs",
    sm: "md",
    md: "md",
    lg: "md",
    xl: "xl",
};
export const QuiBadge = forwardRef((_a, ref) => {
    var { children, iconLeft, iconRight, variant, className, size } = _a, otherProps = __rest(_a, ["children", "iconLeft", "iconRight", "variant", "className", "size"]);
    const variantPrefix = variant && variant !== "default" ? `-${variant}` : "";
    const sizePrefix = size ? `-${size}` : "";
    // If we're only displaying a single icon, or a single character, add a utility class to
    // ensure that this badge is equal in height & width
    const onlyHasOneIcon = !children && (iconRight || iconLeft) && !(iconRight && iconLeft);
    const onlyHasOneDigitChildString = (typeof children === "string" || typeof children === "number") && children.toString().length === 1 && !(iconRight !== null && iconRight !== void 0 ? iconRight : iconLeft);
    const badgeClassName = classNames(`qui-badge${variantPrefix}${sizePrefix}`, {
        [`qui-badge-single-icon-only${sizePrefix}`]: onlyHasOneIcon === true || onlyHasOneDigitChildString === true,
    }, className);
    const iconSize = QUI_BADGE_ICON_SIZE[size !== null && size !== void 0 ? size : "md"];
    const iconSizeProps = {};
    if (iconSize !== "md") {
        iconSizeProps["size"] = iconSize;
    }
    return (React.createElement("div", Object.assign({ ref: ref, className: badgeClassName }, otherProps),
        iconLeft ? React.createElement(QuiIcon, Object.assign({}, iconSizeProps, { icon: iconLeft })) : null,
        children,
        iconRight ? React.createElement(QuiIcon, Object.assign({}, iconSizeProps, { icon: iconRight })) : null));
});
QuiBadge.displayName = "QuiBadge";
